<template>
  <v-app>
    <NavBar v-if="!isEmbedMode" />

    <v-main>
      <NavigationDrawer v-if="!isEmbedMode" />
      <router-view />
    </v-main>

    <!-- 全局页脚 - ICP备案号 -->
    <v-footer v-if="!isEmbedMode" class="icp-footer">
      <v-container>
        <div class="text-center text-caption text-grey-darken-1">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">
            京ICP备2022023996号-1
          </a>
        </div>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>

import NavBar from './components/NavBar.vue';
import NavigationDrawer from './components/NavigationDrawer.vue';
export default {
  components: {
    NavBar,
    NavigationDrawer,
  },
  computed: {
    isEmbedMode() {
      // 检测 URL 参数中是否有 embed=true
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('embed') === 'true';
    }
  }
};
</script>

<style scoped>
.icp-footer {
  background-color: transparent;
  padding: 32px 0 8px 0;
  margin-top: auto;
}

.icp-footer .text-caption {
  font-size: 12px;
  line-height: 1.5;
}

.icp-link {
  color: #757575;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #424242;
  text-decoration: underline;
}
</style>
